import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, BillItemsByChargeEntryCodeController, BillItemsByChargeEntryCodeRequest } from '../../../../../../../src/app/ncs/models/actor/actor';




@Component({
  selector: 'labsample3',
  templateUrl: './labsample3.component.html',
  styleUrls: ['./labsample3.component.scss']
})

export class Labsample3Component implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;

  public Date: Date;





  pdata: any[];
  onDataReady() {
    setTimeout(() => {
      window.print();
      this.isPrinting = true;
      this.router.navigate([{ outlets: { print: null } }]);
    });
  }
  isPrinting = false;

  CurrentBillItemsByChargeEntryCodeController: BillItemsByChargeEntryCodeController[];
  CurrentBillItemsByChargeEntryCodeRequest: BillItemsByChargeEntryCodeRequest;



  LoadBills() {
    this.CurrentBillItemsByChargeEntryCodeRequest = new BillItemsByChargeEntryCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentBillItemsByChargeEntryCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentBillItemsByChargeEntryCodeRequest.ChargeEntryCode = 10074;
    this.CurrentBillItemsByChargeEntryCodeRequest.ConditionalOperator = 10;
    this.GetBillItemsByChargeEntryCodeController();
  }
  GetBillItemsByChargeEntryCodeController() {
    this.StartRefreshing();


    this.actorservice.GetBillItemsByChargeEntryCodeController(this.CurrentBillItemsByChargeEntryCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentBillItemsByChargeEntryCodeController = this.ApiResData.Result;
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {

    this.Date = new Date();
    this.LoadBills();
  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}








